<template>
  <div>
    <AdContractAccepted v-if="acceptedContract" :value="value" @input="close" />
    <AdContractPending v-else :value="value" @input="close" />
  </div>
</template>

<script>
import { AD_CONTRACT } from '@/store/types';
import { mapGetters } from 'vuex';
import AdContractAccepted from './AdContractAccepted';
import AdContractPending from './AdContractPending';

export default {
  name: 'AdContract',
  components: {
    AdContractPending,
    AdContractAccepted,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      acceptedContract: AD_CONTRACT,
    }),
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss">
.ad-contract {
  &__loading-wrapper {
    display: flex;
    justify-content: center;
  }

  &__actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
